module.exports = __webpack_public_path__ + "static/img/5123042d.svg";